import { formatDate } from '@angular/common';
import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { CampaignService } from '@brafton/atlas-api-client';
import { CampaignProject } from '@brafton/common-framework-library';

@Component({
  selector: 'shared-create-campaign-button',
  templateUrl: './create-campaign-button.component.html',
  styleUrls: ['./create-campaign-button.component.scss'],
  host: { class: 'create-campaign-button' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedCreateCampaignButtonComponent {
  disabled = false;
  expanded = false;
  localCampaignName!: string | undefined;

  constructor(
    private campaignService: CampaignService,
    private router: Router,
  ) {}

  @ViewChild('newCampaignForm', { static: true }) newCampaignForm!: NgForm;

  createCampaign(name: string) {
    this.disabled = true;
    const today = formatDate(new Date(), 'd MMM, y', 'en-GB');
    const campaignName = name || 'New Campaign ' + today;
    // this.campaignService.createCampaign(campaignName, null).subscribe((newCampaign: CampaignProject) => {
    //   this.newCampaignForm.resetForm();
    //   this.expanded = false;
    //   this.disabled = false;
    //   this.router.navigate([`/campaigns/${newCampaign.id}`]);
    // });
  }
}
